module.exports = "/images/vendor/flag-icon-css/flags/1x1/cn.svg?a94c93941a4d8907fc2be5a61841c2b9";